// Get the base URL for the current environment
export const getBaseUrl = (): string => {
  // In production, use the actual domain
  if (process.env.NODE_ENV === 'production') {
    return 'https://www.themostuselesswebsite.com';
  }
  
  // In development, use the Vite dev server URL
  return 'http://localhost:5173';
};

// Get site URL for Supabase redirects
export const getSiteUrl = (): string => {
  // If running in WebContainer, use the preview URL
  if (typeof window !== 'undefined' && window.location.hostname.includes('webcontainer')) {
    return window.location.origin;
  }
  return getBaseUrl();
};